module.exports = __webpack_public_path__ + "static/lake-taupo-evening-e25da1c466502f4dbc0f0a5fbf1691a0.jpg";